module.exports = __webpack_public_path__ + "img/bx-classroom-timetable-active.b2ec4911.svg";